import React from 'react';
import PropTypes from 'prop-types';

import FormContext from 'common/components/form/context';

// FormFieldConsumer
//
// Consumes fields provided by FormFieldProvider
//
// Usage:
// <Provider store={store}>
//   <FormFieldProvider
//     url={remoteUrlReturnsFormJson}
//   >
//     <h1>do you like veggies?</h1>
//     <FormFieldConsumer name={'enjoys_veggies'}>
//
//     <div class={'hungry-box'}>
//       <h1>do you enjoy cucumbers or carrots?</h1>
//       <FormFieldConsumer name={'enjoys_cucumbers'}>
//       <FormFieldConsumer name={'enjoys_carrots'}>
//     </div>
//   </FormFieldProvider>
// </Provider>
const FormFieldConsumer = ({name}) => (
  <FormContext.Consumer>
    {(fieldsByName) => {
      return fieldsByName[name];
    }}
  </FormContext.Consumer>
);
FormFieldConsumer.propTypes = {
  name: PropTypes.string.isRequired,
};

export default FormFieldConsumer;
